import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Paper, CircularProgress, IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { GetAddedAccountingFirm } from '../../Redux/Actions/strategyService';
import AddAccountingFirmModal from './AddAccountingFirmModal';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// This would be your new component for displaying fund details
import FundList from './FundList';

const Accounting = () => {
    const dispatch = useDispatch();
    const [accountingFirms, setAccountingFirms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [selectedFirm, setSelectedFirm] = useState(null);

    useEffect(() => {
        setLoading(true);
        dispatch(GetAddedAccountingFirm())
            .then((response) => {
                if (response && response?.payload.statusCode === 200 && response?.payload.data) {
                    setAccountingFirms(response?.payload.data);
                } else {
                    setAccountingFirms([]);
                }
            })
            .catch((error) => {
                return error;
                setAccountingFirms([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [dispatch]);

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleFirmClick = (firm) => {
        setSelectedFirm(firm);
    };

    const handleBackClick = () => {
        setSelectedFirm(null);
    };

    // If a firm is selected, show the FundList component
    if (selectedFirm) {
        return (
            <Box sx={{ p: 3 }}>
                <FundList 
                    firmId={selectedFirm.id} 
                    firmName={selectedFirm.accountingFirm}
                    onBack={handleBackClick}
                />
            </Box>
        );
    }

    // Otherwise show the firms list (original view)
    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    Accounting
                </Typography>
                {accountingFirms && accountingFirms.length > 0 && (
                    <Button
                        variant="contained"
                        onClick={handleOpenModal}
                        sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "4px",
                            px: 2
                        }}
                    >
                        Add Accounting Firm
                    </Button>
                )}
            </Box>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
                    <CircularProgress />
                </Box>
            ) : accountingFirms && accountingFirms.length > 0 ? (
                <Box sx={{ 
                    backgroundColor: "white", 
                    borderRadius: "8px", 
                    p: 2,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)"
                }}>
                    {accountingFirms.map((firm, index) => (
                        <Box 
                            key={index} 
                            sx={{ 
                                p: 2, 
                                display: "flex",
                                alignItems: "center",
                                borderBottom: index < accountingFirms.length - 1 ? "1px solid #eee" : "none",
                                cursor: "pointer",
                            }}
                            onClick={() => handleFirmClick(firm)}
                        >
                            <Box sx={{ 
                                display: "flex", 
                                alignItems: "center", 
                                p: 2,
                                border: "1px solid #eee",
                                borderRadius: "4px",
                                mr: 2,
                                width: "200px"
                            }}>
                                {/* <img 
                                    src="/path-to-nav-logo.png" 
                                    alt="Logo" 
                                    style={{ height: "20px", marginRight: "8px" }} 
                                /> */}
                                <Typography sx={{ fontWeight: "medium" }}>
                                    {firm.accountingFirm}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            ) : (
                <Box sx={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center", 
                    justifyContent: "center",
                    height: "400px",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    p: 3
                }}>
                    <InfoOutlinedIcon 
                        sx={{ 
                            color: "black", 
                            backgroundColor: "white",
                            border: "2px solid black",
                            borderRadius: "50%",
                            padding: "8px",
                            width: "24px",
                            height: "24px",
                            marginBottom: "16px",
                            boxSizing: "content-box"
                        }}
                    />
                    <Typography variant="body1" sx={{ color: "#666", mb: 1 }}>
                        No accounting firm to see yet.
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
                        Add firm to get started
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={handleOpenModal}
                        sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            textTransform: "none",
                            borderRadius: "4px",
                            px: 4,
                            py: 1
                        }}
                    >
                        Add Accounting Firm
                    </Button>
                </Box>
            )}

            <AddAccountingFirmModal open={openModal} handleClose={handleCloseModal} />
        </Box>
    );
};

export default Accounting;